import React from "react";
import "./ProgramBanner.css";
import { useNavigate, useLocation } from "react-router-dom";
import { MdArrowForwardIos } from "react-icons/md";
import { FiShoppingCart } from "react-icons/fi";

export default function ExerciseBanner(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  let bgClassName;
  let imgUrl;
  let imgStyle;

  if (props.label === "diet") {
    bgClassName = props.is_support ? "beginnerCourse" : "professionalCourse";
    imgUrl = "/images/dishes.svg";
  } else {
    bgClassName = props.level === 1 ? "beginnerCourse" : "professionalCourse";
    imgUrl = props.type === "YOGA" ? "/images/yoga.svg" : "/images/weight.png";
    imgStyle =
      props.type === "YOGA"
        ? { transform: "rotate(0deg)" }
        : { transform: "rotate(45deg)" };
  }

  const handleOpenPayment = () => {
    if (path.includes("exercise") || path.includes("diets")) {
      navigate("/coursePayment", { state: { courseData: { ...props } } });
    }
  };

  return (
    <div
      onClick={handleOpenPayment}
      className={`programBanner centeredFlex responsiveWidth ${bgClassName}`}
    >
      <div className="programBannerRight centeredFlex">
        <div>
          {path.includes("exercise") && (
            <MdArrowForwardIos className="programBannerArrow" />
          )}
          <FiShoppingCart className="programBannerCart" />
        </div>
        <div className="programInfo">
          <p>{props.name}</p>
          <span>{props.price} T</span>
        </div>
      </div>
      <img
        src={imgUrl}
        className="programIcon"
        alt="exercise"
        style={imgStyle}
      />
    </div>
  );
}
